<template>
  <div class="template">
    <NewsParams />
    <LoaderFullPage v-if="store.loading" />
    <NewsDatas v-else />
  </div>
</template>

<script setup>
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import NewsParams from "@follaw-fr/components/news/organisms/NewsParams.vue";
import NewsDatas from "@follaw-fr/components/news/organisms/NewsDatas.vue";
import { useNewsStore } from "@follaw-fr/stores/news";

const store = useNewsStore();

store.selectedFilters.from = 0;
store.fetchNewsList();
</script>
